import { type InitiativeAttributes } from './generated/InitiativeAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';
import { HasRecordPositions } from './concerns/HasRecordPositions';
import ColorAttribute, {
  type IColorAttribute,
} from './concerns/ColorAttribute';
import { AtRiskFlaggable } from './concerns/AtRiskFlaggable';

interface Initiative
  extends InitiativeAttributes,
    AtRiskFlaggable,
    HasRecordPositions,
    IColorAttribute {}

@model
@ColorAttribute()
@HasRecordPositions
@AtRiskFlaggable
class Initiative extends ApplicationModel {
  // Start auto-generated
  static typename: 'Initiative' = 'Initiative';
  get typename(): 'Initiative' {
    return 'Initiative';
  }

  static internalTypename: 'Initiative' = 'Initiative';
  get internalTypename(): 'Initiative' {
    return 'Initiative';
  }

  static terminologyName = 'Initiative';

  static inputType = 'InitiativeAttributes!';

  static filterType = 'InitiativeFilters!';
  static filters = { id: '[ID!]', projectId: 'ID' };

  static fields = {
    childrenCount: attr({ readable: true }),
    color: attr({ readable: true }),
    commentsCount: attr({ readable: true }),
    createdAt: attr({ readable: true }),
    currentSchedulingTeamsCount: attr({ readable: true }),
    drillInUrl: attr({
      args: {
        publishableId: 'ID',
        publishableType: 'String',
        viewSnapshotId: 'ID',
        dashboardId: 'ID',
        exportType: 'String',
        bookmarkId: 'ID',
      },
      readable: true,
    }),
    endDate: attr({ readable: true }),
    epicsCount: attr({ readable: true }),
    featuresCount: attr({ readable: true }),
    goalsCount: attr({ readable: true }),
    id: attr({ readable: true }),
    ideasCount: attr({ readable: true }),
    integrationLinksCount: attr({ readable: true }),
    manualRiskComment: attr({ writable: true, readable: true }),
    name: attr({ writable: true, readable: true }),
    parentId: attr({ readable: true }),
    path: attr({ readable: true }),
    position: attr({ writable: true, readable: false }),
    progress: attr({ readable: true }),
    projectId: attr({ readable: true }),
    referenceNum: attr({ readable: true }),
    releasesCount: attr({ readable: true }),
    riskFactors: attr({ readable: true, json: true }),
    riskFactorsCount: attr({ readable: true }),
    schedulingTeamsCount: attr({ readable: true }),
    score: attr({ readable: true }),
    scoringSystemId: attr({ readable: true }),
    startDate: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
    watchersCount: attr({ readable: true }),
    workflowStatusId: attr({ readable: true }),
    assignedToUser: attr.belongsTo({
      writeShape: ['id', 'name', 'email'],
      readable: true,
      typename: 'User',
    }),
    bestEstimate: attr.belongsTo({ readable: true, typename: 'Estimate' }),
    createdByUser: attr.belongsTo({ readable: true, typename: 'User' }),
    description: attr.belongsTo({
      writable: true,
      readable: true,
      typename: 'Note',
    }),
    epoch: attr.belongsTo({ readable: true, typename: 'Epoch' }),
    initialEstimate: attr.belongsTo({ readable: true, typename: 'Estimate' }),
    originalEstimate: attr.belongsTo({ readable: true, typename: 'Estimate' }),
    parent: attr.belongsTo({ readable: true, typename: 'Initiative' }),
    permissions: attr.belongsTo({
      readable: true,
      typename: 'ResourcePermissions',
    }),
    project: attr.belongsTo({
      writeShape: ['id'],
      readable: true,
      typename: 'Project',
    }),
    remainingEstimate: attr.belongsTo({ readable: true, typename: 'Estimate' }),
    researchFolder: attr.belongsTo({
      writeShape: ['id'],
      readable: true,
      typename: 'Page',
    }),
    screenDefinition: attr.belongsTo({
      readable: true,
      typename: 'ScreenDefinition',
    }),
    terminology: attr.belongsTo({
      readable: true,
      typename: 'TerminologyItem',
    }),
    workDone: attr.belongsTo({ readable: true, typename: 'Estimate' }),
    workflowStatus: attr.belongsTo({
      writeShape: ['id', 'name', 'category'],
      readable: true,
      typename: 'WorkflowStatus',
    }),
    addGoals: attr.hasMany({ writable: true, readable: false }),
    bookmarksRecordPositions: attr.hasMany({
      args: { filters: 'RecordPositionFilters' },
      readable: true,
    }),
    childRecordLinks: attr.hasMany({
      args: { filters: 'RecordLinkFilters' },
      readable: true,
    }),
    children: attr.hasMany({ readable: true }),
    comments: attr.hasMany({ readable: true }),
    currentSchedulingTeams: attr.hasMany({ readable: true }),
    customFieldValues: attr.hasMany({
      args: { ids: '[ID!]', keys: '[String!]' },
      readable: true,
    }),
    epics: attr.hasMany({ readable: true }),
    features: attr.hasMany({ readable: true }),
    goals: attr.hasMany({ writable: true, readable: true }),
    ideas: attr.hasMany({ readable: true }),
    integrationLinks: attr.hasMany({ readable: true }),
    parentRecordLinks: attr.hasMany({
      args: { filters: 'RecordLinkFilters' },
      readable: true,
    }),
    releases: attr.hasMany({ readable: true }),
    removeGoals: attr.hasMany({ writable: true, readable: false }),
    schedulingTeams: attr.hasMany({ readable: true }),
    scoreFacts: attr.hasMany({ writable: true, readable: true }),
    tasks: attr.hasMany({ readable: true }),
    watchers: attr.hasMany({ readable: true }),
  };
  // End auto-generated
}

export default Initiative;
